// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"R5-z"};